import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useState } from "react";
import SubCard from "ui-component/cards/SubCard";
import UpdateWorkingDetails from "../UpdateWorkingDetails";
import UpdateSelfWorkingDetails from "../UpdateSelfWorkingDetails";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import WorkIcon from "@mui/icons-material/Work"
import BusinessIcon from "@mui/icons-material/Business"
import CategoryIcon from "@mui/icons-material/Category"
import WorkOutlineIcon from "@mui/icons-material/WorkOutline"
import DateRangeIcon from "@mui/icons-material/DateRange"
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement"
import { Delete } from "@mui/icons-material";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";

const WorkingDetailsCard = ({
  alumniDetails,
  setAlumniDetails,
  handleNavigateWorkingStatus,
  handleNavigate,
  IsConnection,
}) => {

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [removeType, setRemoveType] = useState("")
  const [removeDetails, setRemoveDetails] = useState({})
  const [openEditForSelfEmployment, setOpenEditForSelfEmployment] = useState(false)
  const [alumniId, setAlumniId] = useState('')
  const [workDetails, setWorkingDetails] = useState({})
  const [selfWorkingDetails, setSelfWorkingDetails] = useState({})


  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();


  const handleNavigateIndividualEdit = (alumniId, details) => {
    setRemoveType()
    setAlumniId(alumniId)
    setWorkingDetails(details)
    setOpenEdit(true)
  }
  const handleOpenDelete = (alumniId, details, removeType) => {
    setRemoveType(removeType)
    setAlumniId(alumniId)
    setRemoveDetails(details)
    setOpenDelete(true)
  }
  const handleOpenForSelfEmployment = (alumniId, details) => {
    setAlumniId(alumniId)
    setSelfWorkingDetails(details)
    setOpenEditForSelfEmployment(true)
  }



  const hasMultipleCurrent = (() => {
    const presentCount = [
      ...(alumniDetails?.workingDetails || []),
      // ...(alumniDetails?.selfWorkingDetails || [])
    ].filter(detail => detail.present).length;
    return presentCount > 1;
  })();
  const hasMultipleSelfCurrent = (() => {
    const presentCount = [
      // ...(alumniDetails?.workingDetails || []),
      ...(alumniDetails?.selfWorkingDetails || [])
    ].filter(detail => detail.present).length;
    return presentCount > 1;
  })();

  const handleDeleteWorkExperience = () => {
    axios
      .delete(`/v1/alumni/remove-details?alumniId=${alumniId}&removedTypeId=${removeDetails?.id}&removeType=${removeType}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      })
      .then((value) => {
        setAlumniDetails(value?.data?.data)
        setOpenDelete(false)
        generateTimeStamp();
        dispatch(
          openSnackbar({
            open: true,
            message: "Deleted Successfully.",
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          })
        );
        setOpenEdit(false)

      })
      .catch((error) => {
        if (error.response.status === 404) {
          generateTimeStamp();
          dispatch(
            openSnackbar({
              open: true,
              message: error.response.data.Msg,
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        } else {
          dispatch(
            openSnackbar({
              open: true,
              message: "Something went wrong",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
          generateTimeStamp();
        }
      });
  }

  console.log(alumniDetails?.selfWorkingDetails, "selfWorkingDetails");

  return (
    <>
      <SubCard
        sx={{
          p: 2,
          mt: 2,
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "0.5em",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ffffff",
          },
        }}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <InfoIcon sx={{ marginRight: 1 }} /> */}
              <span style={{ color: "#245081", fontSize: "18px" }}>
                Work Experience
              </span>
            </Typography>
          </div>
        }
        secondary={
          <>
            {!IsConnection && (
              <>
                {alumniDetails?.workingDetails !== null && (
                  <div style={{ cursor: "pointer" }}>
                    <img
                      onClick={() =>
                        handleNavigateWorkingStatus(alumniDetails?.id)
                      }
                      height="20px"
                      alt="icon"
                      src="/assets/images/icons/addIcon.svg"
                    />
                  </div>
                )}
              </>
            )}
          </>
        }
      >
        <Grid container direction="column" spacing={2}>
          {alumniDetails?.workingDetails === null && alumniDetails?.selfWorkingDetails === null ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                py: 2,
              }}
            >
              {!IsConnection ? (
                <IconButton onClick={() => handleNavigateWorkingStatus(alumniDetails?.id)}>
                  <AddIcon sx={{ fontSize: 40 }} />
                </IconButton>
              ) : (
                <Typography>No Working Details Provided</Typography>
              )}
            </Box>
          ) : (
            <>
              {alumniDetails?.workingDetails?.map((data, i) =>
                data?.designation?.trim() ? (
                  <Grid item key={`work-${i}`}>
                    <Paper
                      elevation={1}
                      sx={{
                        p: 2.5,
                        borderRadius: 2,
                        border: "1px solid #f0f0f0",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        },
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Box sx={{ flex: 1 }}>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <Tooltip title="Designation">
                              <WorkIcon sx={{ mr: 1.5, color: "#245081" }} />
                            </Tooltip>
                            <Typography variant="h6" fontWeight={600}>
                              {data?.designation}
                            </Typography>
                            {data?.present && (
                              <Chip label="Current" size="small" color="primary" sx={{ ml: 1.5, height: 24 }} />
                            )}
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                            <Tooltip title="Organization">
                              <BusinessIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                            </Tooltip>
                            <Typography variant="body1">{data?.organizationName}</Typography>
                          </Box>

                          {(data?.industries || data?.otherIndustries) && (
                            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                              <Tooltip title="Industry">
                                <CategoryIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                              </Tooltip>
                              <Typography variant="body2" color="text.secondary">
                                {data?.industries === "Other" ? data?.otherIndustries : data?.industries}
                              </Typography>
                            </Box>
                          )}

                          {(data?.functionalArea || data?.otherFunctionalArea) && (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Tooltip title="Functional Area">
                                <WorkOutlineIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                              </Tooltip>
                              <Typography variant="body2" color="text.secondary">
                                {data?.functionalArea === "Other" ? data?.otherFunctionalArea : data?.functionalArea}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box>
                          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <Tooltip title="Duration">
                              <DateRangeIcon sx={{ mr: 0.5, fontSize: 18, color: "#666" }} />
                            </Tooltip>
                            <Typography variant="body2" color="text.secondary">
                              {(data?.joiningDate && data.joiningDate !== "")
                                ? moment(data.joiningDate).format("MMMM-YYYY")
                                : (data?.joiningDate === "" || data?.joiningDate == null) && data?.startMonth && data?.startYear
                                  ? `${monthNames[data.startMonth - 1] || ""}/${data.startYear}`
                                  : "N/A"}{" "}
                              -{" "}
                              {data?.endDate
                                ? moment(data.endDate).format("MMMM-YYYY")
                                : data?.present
                                  ? "Current"
                                  : data?.endMonth && data?.endYear
                                    ? `${monthNames[data.endMonth - 1] || ""}/${data.endYear}`
                                    : "N/A"}
                            </Typography>
                          </Box>

                          {!IsConnection && (
                            <>
                              <Tooltip title="Edit Details">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => handleNavigateIndividualEdit(alumniDetails?.id, data)}
                                  sx={{
                                    ml: "auto",
                                    bgcolor: "#f5f5f5",
                                    "&:hover": { bgcolor: "#e0e0e0" },
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Details">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleOpenDelete(alumniDetails?.id, data, "WorkingDetails")}
                                  sx={{
                                    ml: 1,
                                    bgcolor: "#f5f5f5",
                                    "&:hover": { bgcolor: "#e0e0e0" },
                                  }}
                                >
                                  <Delete fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </>

                          )}
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ) : null
              )}

              {alumniDetails?.selfWorkingDetails?.map((data, i) =>
                // data?.designation ? (
                <Grid item key={`self-${i}`}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2.5,
                      borderRadius: 2,
                      border: "1px solid #f0f0f0",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                          <Tooltip title="Self Employment">
                            <SelfImprovementIcon sx={{ mr: 1.5, color: "#245081" }} />
                          </Tooltip>
                          <Typography variant="h6" fontWeight={600}>
                            {data?.designation}
                          </Typography>
                          {data?.present && (
                            <Chip label="Current" size="small" color="primary" sx={{ ml: 1.5, height: 24 }} />
                          )}
                        </Box>

                        {data?.detailRole && (
                          <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                            <Tooltip title="Role Detail">
                              <WorkOutlineIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                            </Tooltip>
                            <Typography variant="body1">{data?.detailRole}</Typography>
                          </Box>
                        )}

                        {(data?.industries || data?.otherIndustries) && (
                          <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                            <Tooltip title="Industry">
                              <CategoryIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                            </Tooltip>
                            <Typography variant="body2" color="text.secondary">
                              {data?.industries === "Other" ? data?.otherIndustries : data?.industries}
                            </Typography>
                          </Box>
                        )}

                        {(data?.functionalArea || data?.otherFunctionalArea) && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Tooltip title="Functional Area">
                              <WorkOutlineIcon sx={{ mr: 1, fontSize: 20, color: "#666" }} />
                            </Tooltip>
                            <Typography variant="body2" color="text.secondary">
                              {data?.functionalArea === "Other" ? data?.otherFunctionalArea : data?.functionalArea}
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      <Box>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                          <Tooltip title="Duration">
                            <DateRangeIcon sx={{ mr: 0.5, fontSize: 18, color: "#666" }} />
                          </Tooltip>
                          <Typography variant="body2" color="text.secondary">
                            {data?.startDate
                              ? moment(data.startDate).format("MMMM-YYYY")
                              : data?.startMonth && data?.startYear
                                ? `${monthNames[data.startMonth - 1] || ""}/${data.startYear}`
                                : "N/A"}{" "}
                            -{" "}
                            {data?.endDate
                              ? moment(data.endDate).format("MMMM-YYYY")
                              : data?.present
                                ? "Current"
                                : data?.endMonth && data?.endYear
                                  ? `${monthNames[data.endMonth - 1] || ""}/${data.endYear}`
                                  : "N/A"}
                          </Typography>
                        </Box>

                        {!IsConnection && (
                          <>
                            <Tooltip title="Edit Details">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleOpenForSelfEmployment(alumniDetails?.id, data)}
                                sx={{
                                  ml: "auto",
                                  bgcolor: "#f5f5f5",
                                  "&:hover": { bgcolor: "#e0e0e0" },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Details">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleOpenDelete(alumniDetails?.id, data, "SelfEmployeeDetails")}
                                sx={{
                                  ml: 1,
                                  bgcolor: "#f5f5f5",
                                  "&:hover": { bgcolor: "#e0e0e0" },
                                }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
                // ) : null
              )}
            </>
          )}
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <Divider />
          </Box>
        </Grid>
      </SubCard>


      {openEdit && (
        <Dialog open={openEdit} onClose={() => setOpenEdit(false)}>
          <DialogTitle>Update Employment Details</DialogTitle>
          <DialogContent>
            <UpdateWorkingDetails hasMultipleCurrent={hasMultipleCurrent} setAlumniDetails={setAlumniDetails} setOpenEdit={setOpenEdit} alumniDetails={workDetails} alumniId={alumniId} />
          </DialogContent>
        </Dialog>
      )}
      {openEditForSelfEmployment && (
        <Dialog open={openEditForSelfEmployment} onClose={() => setOpenEditForSelfEmployment(false)}>
          <DialogTitle>Update Self Employment Details</DialogTitle>
          <DialogContent>
            <UpdateSelfWorkingDetails hasMultipleCurrent={hasMultipleSelfCurrent} setAlumniDetails={setAlumniDetails} setOpenEdit={setOpenEditForSelfEmployment} alumniDetails={selfWorkingDetails} alumniId={alumniId} />
          </DialogContent>
        </Dialog>
      )}
      {openDelete && (
        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete your Work Experience {removeDetails?.designation}?
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpenDelete(false)}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{ ml: 2 }}
                onClick={handleDeleteWorkExperience}
              >
                Delete
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default WorkingDetailsCard;
